import React, { useState, useEffect } from 'react';
import AdminLayout from './AdminLayout';
import adminApi from '../../api/adminClient';
import './Admin.css';

const FIELD_LABELS = {
  workPeriodFrom:    '근로 시작일',
  workPeriodTo:      '근로 종료일',
  workTask:          '담당 업무',
  workPlace:         '업무 장소',
  workTimeHours:     '근로 시간',
  workTimeStart:     '시업 시간',
  workTimeEnd:       '종업 시간',
  workTimeBreak:     '휴게 시간',
  breakTimeDesc:     '휴게 시간 상세',
  workType:          '근로 형태',
  workHoursDesc:     '근로시간 설명',
  salaryCondition:   '급여 조건',
  salaryCalcFrom:    '임금 산정 시작',
  salaryCalcTo:      '임금 산정 종료',
  salaryPaymentDate: '임금 지급일',
};

function toCamel(row) {
  return {
    id:                row.id,
    eventId:           row.event_id,
    eventName:         row.event_name,
    templateId:        row.template_id,
    workPeriodFrom:    row.work_period_from,
    workPeriodTo:      row.work_period_to,
    workTask:          row.work_task,
    workPlace:         row.work_place,
    workTimeHours:     row.work_time_hours,
    workTimeStart:     row.work_time_start,
    workTimeEnd:       row.work_time_end,
    workTimeBreak:     row.work_time_break,
    breakTimeDesc:     row.break_time_desc,
    workType:          row.work_type,
    workHoursDesc:     row.work_hours_desc,
    salaryCondition:   row.salary_condition,
    salaryCalcFrom:    row.salary_calc_from,
    salaryCalcTo:      row.salary_calc_to,
    salaryPaymentDate: row.salary_payment_date,
    createdAt:         row.created_at,
    updatedAt:         row.updated_at,
  };
}

/* ── 목록 ── */
export default function AdminContractContents() {
  const [items, setItems] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [editing, setEditing] = useState(null); // item | null
  const [deleteModal, setDeleteModal] = useState(null);
  const [deletePw, setDeletePw] = useState('');
  const [deleteError, setDeleteError] = useState('');
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => { loadData(); }, []);

  async function loadData() {
    try {
      setLoading(true);
      const [data, tmplData] = await Promise.all([
        adminApi.get('/contract-contents'),
        adminApi.get('/contract-templates'),
      ]);
      setItems(data.map(toCamel));
      setTemplates(tmplData);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  function openDeleteModal(item) {
    setDeleteModal({ item });
    setDeletePw('');
    setDeleteError('');
  }

  async function handleDeleteConfirm() {
    if (!deletePw) { setDeleteError('비밀번호를 입력해 주세요.'); return; }
    setDeleteLoading(true);
    setDeleteError('');
    try {
      await adminApi.post('/auth/verify-password', { password: deletePw });
    } catch (err) {
      setDeleteError(err.message || '비밀번호가 올바르지 않습니다.');
      setDeleteLoading(false);
      return;
    }
    try {
      await adminApi.delete(`/contract-contents/${deleteModal.item.eventId}`);
      setItems(prev => prev.filter(i => i.eventId !== deleteModal.item.eventId));
      setDeleteModal(null);
    } catch (err) {
      setDeleteError(err.message || '삭제 중 오류가 발생했습니다.');
    } finally {
      setDeleteLoading(false);
    }
  }

  if (editing !== null) {
    return (
      <AdminLayout>
        <ContentEditForm
          item={editing}
          templates={templates}
          onCancel={() => setEditing(null)}
          onSaved={(updated) => {
            setItems(prev => prev.map(i => i.eventId === updated.eventId ? updated : i));
            setEditing(null);
          }}
        />
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      {/* 삭제 확인 모달 */}
      {deleteModal && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          zIndex: 20000, display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{
            background: '#fff', borderRadius: 8, padding: '2rem',
            width: '100%', maxWidth: 400, boxShadow: '0 8px 32px rgba(0,0,0,0.22)',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '1rem' }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: 700, color: '#dc2626' }}>내용 삭제</h3>
            </div>
            <p style={{ marginBottom: '1.25rem', fontSize: '0.95rem', color: '#374151' }}>
              <b>{deleteModal.item.eventName}</b> 업무의 저장된 계약서 내용을 삭제하시겠습니까?<br />
              관리자 비밀번호를 입력하세요.
            </p>
            <div className="form-group" style={{ marginBottom: '0.75rem' }}>
              <label style={{ fontSize: '0.875rem', fontWeight: 600 }}>관리자 비밀번호</label>
              <input
                type="password"
                value={deletePw}
                onChange={e => { setDeletePw(e.target.value); setDeleteError(''); }}
                onKeyDown={e => e.key === 'Enter' && handleDeleteConfirm()}
                placeholder="비밀번호 입력"
                autoFocus
                style={{ width: '100%', marginTop: '0.3rem' }}
              />
            </div>
            {deleteError && (
              <div className="form-error" style={{ marginBottom: '0.75rem' }}>{deleteError}</div>
            )}
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button className="btn btn-outline-navy" onClick={() => setDeleteModal(null)} disabled={deleteLoading}>취소</button>
              <button
                className="btn btn-primary"
                style={{ background: '#dc2626', borderColor: '#dc2626' }}
                onClick={handleDeleteConfirm}
                disabled={deleteLoading}
              >
                {deleteLoading ? '삭제 중...' : '삭제'}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="admin-header">
        <div>
          <h1>근로계약서 내용 관리</h1>
          <p className="text-muted">업무별로 저장된 계약서 조항 내용입니다. 근로계약서 등록 시 불러오기로 자동 채울 수 있습니다. 총 {items.length}건.</p>
        </div>
      </div>

      {loading && <div className="state-message">불러오는 중입니다...</div>}
      {!loading && error && <div className="state-message state-message--error">{error}</div>}

      {!loading && !error && (
        items.length === 0 ? (
          <div className="state-message">
            저장된 내용이 없습니다.<br />
            <span className="text-muted" style={{ fontSize: '0.875rem' }}>근로계약서를 등록하면 업무별 내용이 자동으로 저장됩니다.</span>
          </div>
        ) : (
          <div className="admin-table-wrapper">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>업무명</th>
                  <th>근로 기간</th>
                  <th>담당 업무</th>
                  <th>업무 장소</th>
                  <th style={{ minWidth: 110 }}>최종 수정</th>
                  <th style={{ width: 140 }}>관리</th>
                </tr>
              </thead>
              <tbody>
                {items.map(item => (
                  <React.Fragment key={item.eventId}>
                    <tr
                      className="admin-table__row-clickable"
                      onClick={() => setOpenId(openId === item.eventId ? null : item.eventId)}
                    >
                      <td className="admin-table__title">{item.eventName}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        {item.workPeriodFrom || '-'}<br />
                        <span className="text-muted" style={{ fontSize: '0.82rem' }}>~ {item.workPeriodTo || '-'}</span>
                      </td>
                      <td>{item.workTask || '-'}</td>
                      <td>{item.workPlace || '-'}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        <div>{String(item.updatedAt).slice(0, 10)}</div>
                        <div className="text-muted" style={{ fontSize: '0.8rem', marginTop: '0.15rem' }}>{String(item.updatedAt).slice(11, 16)}</div>
                      </td>
                      <td className="admin-table__actions" onClick={e => e.stopPropagation()}>
                        <button
                          className="admin-action-btn"
                          onClick={() => setEditing(item)}
                        >
                          수정
                        </button>
                        <button
                          className="admin-action-btn admin-action-btn--danger"
                          onClick={() => openDeleteModal(item)}
                        >
                          삭제
                        </button>
                      </td>
                    </tr>
                    {openId === item.eventId && (
                      <tr>
                        <td colSpan={6} className="admin-table__detail-row">
                          <div className="job-info-grid">
                            {Object.entries(FIELD_LABELS).map(([key, label]) => (
                              <div key={key} className="job-info-item">
                                <span className="job-info-item__label">{label}</span>
                                <span className="job-info-item__value">{item[key] || '-'}</span>
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </AdminLayout>
  );
}

/* ── 수정 폼 ── */
function ContentEditForm({ item, templates, onCancel, onSaved }) {
  const [form, setForm] = useState({
    templateId:        item.templateId ? String(item.templateId) : '',
    workPeriodFrom:    item.workPeriodFrom    || '',
    workPeriodTo:      item.workPeriodTo      || '',
    workTask:          item.workTask          || '',
    workPlace:         item.workPlace         || '',
    workTimeHours:     item.workTimeHours     || '',
    workTimeStart:     item.workTimeStart     || '',
    workTimeEnd:       item.workTimeEnd       || '',
    workTimeBreak:     item.workTimeBreak     || '',
    breakTimeDesc:     item.breakTimeDesc     || '',
    workType:          item.workType          || '',
    workHoursDesc:     item.workHoursDesc     || '',
    salaryCondition:   item.salaryCondition   || '',
    salaryCalcFrom:    item.salaryCalcFrom    || '',
    salaryCalcTo:      item.salaryCalcTo      || '',
    salaryPaymentDate: item.salaryPaymentDate || '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [cancelConfirm, setCancelConfirm] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  async function handleSave() {
    setSaving(true);
    setError(null);
    try {
      await adminApi.put(`/contract-contents/${item.eventId}`, {
        templateId:        form.templateId || null,
        workPeriodFrom:    form.workPeriodFrom,
        workPeriodTo:      form.workPeriodTo,
        workTask:          form.workTask,
        workPlace:         form.workPlace,
        workTimeHours:     form.workTimeHours,
        workTimeStart:     form.workTimeStart,
        workTimeEnd:       form.workTimeEnd,
        workTimeBreak:     form.workTimeBreak,
        breakTimeDesc:     form.breakTimeDesc,
        workType:          form.workType,
        workHoursDesc:     form.workHoursDesc,
        salaryCondition:   form.salaryCondition,
        salaryCalcFrom:    form.salaryCalcFrom,
        salaryCalcTo:      form.salaryCalcTo,
        salaryPaymentDate: form.salaryPaymentDate,
      });
      onSaved({ ...item, ...form, templateId: form.templateId || null, updatedAt: new Date().toISOString() });
    } catch (err) {
      setError(err.message || '저장 중 오류가 발생했습니다.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      {/* 취소 확인 모달 */}
      {cancelConfirm && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          zIndex: 20000, display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{
            background: '#fff', borderRadius: 8, padding: '2rem',
            width: '100%', maxWidth: 360, boxShadow: '0 8px 32px rgba(0,0,0,0.22)',
            textAlign: 'center',
          }}>
            <p style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1.5rem', color: 'var(--navy-800)' }}>
              취소하시겠습니까?<br />
              <span style={{ fontSize: '0.875rem', fontWeight: 400, color: '#6b7280' }}>변경 사항이 저장되지 않습니다.</span>
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
              <button
                className="btn btn-primary"
                style={{ minWidth: 80 }}
                onClick={() => { setCancelConfirm(false); onCancel(); }}
              >
                예
              </button>
              <button
                className="btn btn-outline-navy"
                style={{ minWidth: 80 }}
                onClick={() => setCancelConfirm(false)}
              >
                아니오
              </button>
            </div>
          </div>
        </div>
      )}

      <button className="back-btn" onClick={() => setCancelConfirm(true)}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
        목록으로
      </button>

      <div className="admin-form-card">
        <h2 style={{ marginBottom: '0.35rem' }}>계약서 내용 수정</h2>
        <p className="text-muted" style={{ marginBottom: '1.5rem', fontSize: '0.875rem' }}>
          업무: <strong>{item.eventName}</strong> &nbsp;|&nbsp; 갑·을 정보 및 추가 인적 정보는 이 화면에서 수정하지 않습니다.
        </p>

        {error && <div className="form-error" style={{ marginBottom: '1rem' }}>{error}</div>}

        <div className="form-group">
          <label>계약서 템플릿</label>
          <select name="templateId" value={form.templateId} onChange={handleChange}>
            <option value="">템플릿 선택 (없어도 무관)</option>
            {templates.map(t => (
              <option key={t.id} value={t.id}>{t.name}{t.is_active ? ' (기본)' : ''}</option>
            ))}
          </select>
        </div>

        <h4 className="admin-form-section-title">제3조 [근로 계약 기간]</h4>
        <div className="form-row-2">
          <div className="form-group">
            <label>시작일</label>
            <input type="date" name="workPeriodFrom" value={form.workPeriodFrom} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>종료일</label>
            <input type="date" name="workPeriodTo" value={form.workPeriodTo} onChange={handleChange} />
          </div>
        </div>

        <h4 className="admin-form-section-title">제4조 [담당 업무 및 업무 장소]</h4>
        <div className="form-row-2">
          <div className="form-group">
            <label>담당 업무</label>
            <input name="workTask" value={form.workTask} onChange={handleChange} placeholder="예: 행사 진행 보조" />
          </div>
          <div className="form-group">
            <label>업무 장소</label>
            <input name="workPlace" value={form.workPlace} onChange={handleChange} placeholder="예: ○○컨벤션센터" />
          </div>
        </div>

        <h4 className="admin-form-section-title">제5조 [근무 시간 및 휴게 시간]</h4>
        <div className="form-row-2">
          <div className="form-group">
            <label>근로 시간</label>
            <input name="workTimeHours" value={form.workTimeHours} onChange={handleChange} placeholder="예: 09:00~18:00" />
          </div>
          <div className="form-group">
            <label>시업 시간</label>
            <input name="workTimeStart" value={form.workTimeStart} onChange={handleChange} placeholder="예: 09:00" />
          </div>
        </div>
        <div className="form-row-2">
          <div className="form-group">
            <label>종업 시간</label>
            <input name="workTimeEnd" value={form.workTimeEnd} onChange={handleChange} placeholder="예: 18:00" />
          </div>
          <div className="form-group">
            <label>휴게 시간</label>
            <input name="workTimeBreak" value={form.workTimeBreak} onChange={handleChange} placeholder="예: 60분" />
          </div>
        </div>
        <div className="form-group">
          <label>휴게 시간 상세</label>
          <input name="breakTimeDesc" value={form.breakTimeDesc} onChange={handleChange} placeholder="예: 점심,저녁 식사시간 외 추가 휴게시간 有" />
        </div>

        <h4 className="admin-form-section-title">제6조 [임금의 구성항목 및 산정기준]</h4>
        <div className="form-row-2">
          <div className="form-group">
            <label>근로 형태</label>
            <input name="workType" value={form.workType} onChange={handleChange} placeholder="예: 아르바이트" />
          </div>
          <div className="form-group">
            <label>근로시간 설명</label>
            <input name="workHoursDesc" value={form.workHoursDesc} onChange={handleChange} placeholder="예: 행사기간 內 3일" />
          </div>
        </div>
        <div className="form-group">
          <label>급여 조건</label>
          <input name="salaryCondition" value={form.salaryCondition} onChange={handleChange} placeholder="예: 일급 120,000" />
        </div>

        <h4 className="admin-form-section-title">제7조 [임금의 계산 및 지급방법]</h4>
        <div className="form-row-2">
          <div className="form-group">
            <label>임금 산정 시작일</label>
            <input type="date" name="salaryCalcFrom" value={form.salaryCalcFrom} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>임금 산정 종료일</label>
            <input type="date" name="salaryCalcTo" value={form.salaryCalcTo} onChange={handleChange} />
          </div>
        </div>
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label>임금 지급일</label>
          <input type="date" name="salaryPaymentDate" value={form.salaryPaymentDate} onChange={handleChange} />
        </div>
      </div>

      <div className="admin-form-actions" style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid var(--gray-100)' }}>
        <button type="button" className="btn btn-outline-navy" onClick={() => setCancelConfirm(true)}>취소</button>
        <button type="button" className="btn btn-primary" onClick={handleSave} disabled={saving}>
          {saving ? '저장 중...' : '저장'}
        </button>
      </div>
    </div>
  );
}
